import { render, staticRenderFns } from "./team.player.add.new.vue?vue&type=template&id=cefcb8de&scoped=true&"
import script from "./team.player.add.new.vue?vue&type=script&lang=ts&"
export * from "./team.player.add.new.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefcb8de",
  null
  
)

export default component.exports